/**
 * <TutorDelayMinutesStep> — « Je vais être en retard de » (organism).
 *
 * L'ancien `SelectDelayComponent` : les trois durées de `delayOptions` (5, 10, 15 min), en pilules
 * (`<LateMinutesPicker>`), et la règle qui les borne — au-delà de 15 minutes, c'est une absence.
 */
import React from "react"

import { Stack } from "../../atoms/containers/Stack"
import { Text } from "../../atoms/typography/Text"
import { LateMinutesPicker } from "../../molecules/LateMinutesPicker"

/** Les trois durées de l'ancien `delayOptions` : au-delà de 15 min, c'est une absence. */
const TUTOR_LATE_MINUTES = [5, 10, 15]

export type TutorDelayMinutesStepProps = {
    /** Minutes choisies, ou `null` tant que rien n'est choisi. */
    minutes: number | null
    onSelect: (minutes: number) => void
    testID?: string
}

export function TutorDelayMinutesStep(props: TutorDelayMinutesStepProps) {
    const { minutes, onSelect, testID } = props
    return (
        <Stack gap="3" testID={testID}>
            <LateMinutesPicker value={minutes} onChange={onSelect} options={TUTOR_LATE_MINUTES} />
            <Text size="text-sm" color="text-muted">
                Au-delà de 15 minutes de retard, il faut signaler une absence immédiatement.
            </Text>
        </Stack>
    )
}
